module.exports = __webpack_public_path__ + "assets/a358577d1b1ae1a315afbed1ccdeee8e.svg";